"use client"

import { Button } from "@/components/ui/button"
import { KnowledgeBaseFolderAssignmentMenu } from "./folder-assignment-menu"
import type { KnowledgeBaseAgentRef, KnowledgeBaseFolderView } from "@/server-actions/knowledge-base-folders"
import { useTranslations } from "next-intl"


interface KnowledgeBaseFolderListActionsProps {
  folder: KnowledgeBaseFolderView
  agents: KnowledgeBaseAgentRef[]
  canAssign: boolean
  onOpen: (folderId: string) => void
  onUpdated: () => Promise<void>
}

export function KnowledgeBaseFolderListActions({
  folder,
  agents,
  canAssign,
  onOpen,
  onUpdated,
}: KnowledgeBaseFolderListActionsProps) {
  const tUi = useTranslations("Ai.AiKnowledgeBaseFolderListActions")

  return (
    <div className="flex min-w-0 shrink-0 gap-2 sm:flex-col [&>button]:flex-1 sm:[&>button]:w-full sm:[&>button]:flex-none">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-12 text-base sm:h-9 sm:text-sm"
        onClick={() => onOpen(folder.id)}
      >
        <span key={tUi("open")}>{tUi("open")}</span></Button>
      {canAssign && (
        <KnowledgeBaseFolderAssignmentMenu folder={folder} agents={agents} onUpdated={onUpdated} />
      )}
    </div>
  )
}
